

const defaultStyles = {
    mainButton: {
        width: '140px',
        height: '80px',
    },
};

var objDefaultButtons = {
    // <summary>
    // This object holds functions for the default menu buttons
    // </summary>

    _setMainButton: function (id, icon, label) {
        // creates a new button with main button style
        var obj = $("<div>");
        if (id.length > 0) obj.attr("id", id);
        obj.addClass("btnMainItem standard float-box").html(icon + "<p>" + label + "</p>").css(defaultStyles.mainButton);
        return obj
    },    

};



const ButtonMenuStyle = {
    
    btnStyle: {
        height: "39px",
        boxSizing: "border-box",
        fontSize: "10px",
        lineHeight:"1.5em",
        padding: "4px 0",
        marginRight: "1px",
    },
   
    infoStyle: {
        'boxSizing': "border-box",
        fontSize: "8px",
        fontWeight:"bold"
    },

    headerStyle: {
        'font-size': '10px',
        'font-weight': 'normal',
        textAlign: 'center',
        marginRight: '1px',
        borderLeft:"1px solid #000!important"
    },
    iconStyle: { fontSize: '12px' }
};



var ButtonMenu = {
    source: "vcButton.JS",

    // <summary>
    // This object holds functions for adding a new button group/menu with header
    // </summary>

    _setMenuGroup: function (id, marginRight) {
        // set menu div - contains finally header and menu buttons
        try {
            let obj = $("<div>").addClass("float-box");
            if (id.length > 0) obj.attr("id", id);
            if (marginRight) obj.addClass("vc-grid-margin-right");
            return obj;
        } catch (e) { writeError(ButtonMenu.source + '._setMenuGroup', ex); return null; }
    },

    _setMenuHeader: function (id, label) {
        // sets the header of the menu - if header is desired
        try {
            let obj = $("<div>");
            if (id.length > 0) obj.attr("id", id);
            ButtonMenu._setHeaderStyle(obj);
            obj.addClass("vc-list-header-simple").html(label);
            return obj;
        } catch (e) { writeError(ButtonMenu.source + '._setMenuGroup', ex); return null; }
    },

    _setHeaderStyle: function (obj) {
        // sets the header style with a hardcoded padding
        try {
            obj.css(ButtonMenuStyle.headerStyle);
            // save current style and add padding separately - otherwise !important is not overtaken
            var currentStyle = obj.attr('style') || '';
            var newStyle = currentStyle + 'padding: 3px !important;';
            obj.attr('style', newStyle);
        } catch (e) { writeError(ButtonMenu.source + '._setHeaderStyle', ex);  }
    },

    _setHeaderWidth: function (obj, id) {
        // sets the header width - actually not necessary, currently only for interval menu
        // TODO MKU: needs to be checked!!
        try {
            let divId = "#" + id;
            let btn = obj.vcMenu.menu.wrapper.find(divId + " .button-toggle");
            let margin = 1 * (btn.length - 1);
            let w = (btn.outerWidth() * btn.length) + margin;

            obj.vcMenu.menu.wrapper.find(divId + " .vc-list-header-simple").css({ "width": w, "box-sizing": "border-box" }); // set width of menu header 
        } catch (e) { writeError(ButtonMenu.source + '._setHeaderWidth', ex);  }
    },

    _setMenuButton: function (id, data, cssClass, icon, label, width) {
        // creates a new top menu button
        try {
            let obj = $("<div>");
            if (id.length > 0) obj.attr("id", id);
            if (data.length > 0) { obj.data(data[0], data[1]); }
            if (cssClass.length > 0) obj.addClass(cssClass);
            obj.addClass("button-toggle").html(icon + label).css(ButtonMenuStyle.btnStyle);

            var w = width > 0 ? width : "78px";
            obj.css("width", w);

            return obj;
        } catch (e) { writeError(ButtonMenu.source + '._setMenuButton', ex); return null; }
    },  


    _setWidth: function (obj) {
        // sets the header width - actually not necessary, currently only for interval menu
        // TODO MKU: needs to be checked!!
        try {
            let btn = obj.find(".button-toggle");
            if (btn.length == 0) {
                obj.hide();
                return true;
            }

            let margin = 1 * (btn.length);
            let w = ((btn.outerWidth()) * btn.length) + margin;

            obj.css({ "width": w, "box-sizing": "border-box" });
            return true;
        } catch (e) { writeError(ButtonMenu.source + '._setWidth', ex); return false; }
    },

    _setSimpleButton: function (id, data, cssClass, icon, label, breakLine, addInfo, width) {
        // generats a simple button - optionally a line break for captions and a div (right/top) for additional infos can be added
        try {
            let obj = $("<div>").data("label", label);
            if (id.length > 0) obj.attr("id", id);
            if (data.length > 0) { obj.data(data[0], data[1]); }
            if (cssClass.length > 0) obj.addClass(cssClass);
            obj.addClass("button-toggle float-box").append(icon.css(ButtonMenuStyle.iconStyle), $("<br>")).css(ButtonMenuStyle.btnStyle);

            var w = width > 0 ? width : "78px";
            obj.css("width", w);

            obj.append(ButtonMenu._getText(obj, label, breakLine, addInfo));
          
            return obj;
        } catch (e) { writeError(ButtonMenu.source + '._setSimpleButton', ex); return null }
    },  
   

    _getText: function (obj, label, breakLine, addInfo) {
        // adds the text with an optional line break
        try {
            if (breakLine) obj.css("line-height", "1em");
            obj.append(label);
            if (addInfo) {
                obj.css("position", "relative");
                obj.append($("<div>").addClass("info-line").css(ButtonMenuStyle.infoStyle).html(""));
            }
            return obj;
        } catch (e) { writeError(ButtonMenu.source + '._getText', ex); return null }
    },  


};